/*
 * Used in execute report
 */
import React from 'react';
import {Intent, Position, Toaster, ProgressBar} from '@blueprintjs/core';

import {EXECUTION_STATUS} from './constants';

import './toast.scss';

const progressToaster = Toaster.create({
  className: 'execute-report-progress-toast',
  position: Position.TOP_RIGHT
});

const addName = (name?: string) => name ? ` '${name}'` : '';

export const getMessage = (
  name?: string,
  executionStatus?: string,
  executionId?: string,
) => {
  /*
   * If `executionId` is provided, link to execution.
   */
  const _name = addName(name);
  let message: any = `Executing report${_name}`;

  if (!executionStatus) {
    return message;
  }

  if (executionStatus === EXECUTION_STATUS.SUCCESS) {
    message = `Report${_name} executed successfully!`
  } else if (executionStatus === EXECUTION_STATUS.FAILED) {
    message = `Report${_name} execution failed!`
  }
  if (executionId) {
    return (<>{message} <LinkToLogs executionId={executionId}/></>);
  }

  return message;
}

const getIntent = (executionStatus?: string) => {
  let intent: any = Intent.NONE;

  if (!executionStatus) {
    return intent;
  }

  if (executionStatus === EXECUTION_STATUS.SUCCESS) {
    intent = Intent.SUCCESS;
  } else if (executionStatus === EXECUTION_STATUS.FAILED) {
    intent = Intent.DANGER;
  }
  return intent
};

export const LinkToLogs = ({executionId}: any) => {
  return (
    <a href={`/a/log/${executionId}`}><strong>  See Execution.</strong></a>
  )
};

export const getProgressToastConfig = (
  message?: any,
  executionStatus?: string,
  timeout: number = 2000,
): any => {
  const intent = getIntent(executionStatus);

  const animate = intent === Intent.NONE; /* animate only if */
  return {
    className: "",
    message: (
      <>
        <>{message}</>
        <ProgressBar
          intent={intent}
          value={100}
          animate={animate}
          stripes={animate}
        />
      </>
    ),
    onDismiss: (didTimeoutExpire: boolean) => {

    },
    timeout, // -1 means forever
  };
};

export const createProgressToast = (name?: string, executionStatus?: string): string => {
  const message: string = getMessage(name, executionStatus);
  const config = getProgressToastConfig(message, executionStatus, -1);

  const key = progressToaster.show(config);

  return key;
};

export const updateProgressToast = (key: string, config: any) => {
  progressToaster.show(config, key);
};

export const closeProgressToast = (key: string) => {
  progressToaster.dismiss(key);
}

export const updateProgressToastMessage = (key: string, name?: string, lastResult?: any) => {
  /*
   * Create toast message, create config and update existing toast.
   */
  const message = getMessage(name, lastResult?.status, lastResult?.uid);
  const config = getProgressToastConfig(
    message,
    lastResult?.status,
    5000
  );
  updateProgressToast(key as string, config);
};
